import React from 'react';

export enum CurrentInformation {
    ENABLE_SERVICE = 'ENABLE_SERVICE',
    TRANSMISSION_SERVICE = 'TRANSMISSION_SERVICE',
    CHECK_DETAIL = 'CHECK_DETAIL',
    CHECK_HISTORIC = 'CHECK_HISTORIC',
    CONFIRM_TRANSMISSION = 'CONFIRM_TRANSMISSION',
    ERROR_TRANSMISSION = 'ERROR_TRANSMISSION',
    TRANSMITION_REDIRECT = 'ENABLE TRANSMITION REDIRECTION',
    PAYROLL_ERROR = 'PAYROLL_ERROR',
}

export const getModalInformation = (date?: string): { [key: string]: React.ReactElement } => {
    return {
        [CurrentInformation.ENABLE_SERVICE]: (
            <p>
                Para continuar debe habilitarse, de clic en confirmar para ser dirigido a una nueva pestaña donde podrá realizar
                el proceso
            </p>
        ),
        [CurrentInformation.TRANSMISSION_SERVICE]: (
            <p>
                En este momento serás redirigido a la sección de <strong>Transmitir nómina electrónica</strong> para realizar el
                proceso de Transmisión. En caso de que tengas dudas acerca de este proceso te recomendamos ver nuevamente el video
                completo.
            </p>
        ),
        [CurrentInformation.TRANSMITION_REDIRECT]: (
            <p>La habilitación está en proceso. Una vez sea exitosa, de clic en confirmar.</p>
        ),
        [CurrentInformation.CHECK_DETAIL]: (
            <p>
                En este momento serás redirigido a nuestro portal de Nómina Electrónica para que verifiques el detalle de tu
                transmisión.
            </p>
        ),
        [CurrentInformation.CHECK_HISTORIC]: (
            <p>
                En este momento te vamos a redirigir al portal de Nómina Electrónica donde podrás visualizar el histórico de tus
                transmisiones.
            </p>
        ),
        [CurrentInformation.ERROR_TRANSMISSION]: (
            <p>
                En este momento no es posible realizar la transmisión de la nómina electrónica por favor inténtalo nuevamente más
                tarde.
            </p>
        ),
        [CurrentInformation.CONFIRM_TRANSMISSION]: (
            <p>
                Estás a punto de realizar la transmisión del periodo <span className="date">{date}</span>. Recuerda haber validado
                la información del resumen de la transmisión. Si estás seguro que la información está completa y actualizada haz
                clic en&nbsp; <strong>Confirmar.</strong>
            </p>
        ),
    };
};
